import * as _ from "lodash";
import {Dictionary, sum} from "lodash";
import {IComponentOptions, ILogService} from "angular";
import {Application} from "../../../shared/model/Application";
import {Assessment} from "../../../shared/model/Assessment";
import {PriorCourseUnit} from "../../../shared/model/PriorCourseUnit";
import {PriorCourse} from "../../../shared/model/PriorCourse";
import {isSystemAccepted as checkSystemAccepted, isSystemRejected as checkSystemRejected} from "../../../shared/model/ApplicationStatusUtil";
import "./application-summary.less";
import {LoadingService} from "../../../shared/loading/loading.service";
import {ApplicationService} from "../../../shared/application/application.service";
import {StateService} from "@uirouter/angularjs";

class ApplicationSummaryController {

    public application: Application;
    public currentUser: any;
    public assessments: Assessment[];
    public applicationCourseOfferStatus: any;
    public priorUnitMap: Dictionary<PriorCourseUnit>;
    public unitInstitutionMap: any;
    public approvedCreditPoints: number;
    public acceptedCreditPoints: number;
    private selectedAttachment: any;
    private index: number = 0;
    public messageIn2ndBox: string;
    public messageIn4thBox: string;

    public courseDocuments: any[] = [];
    public courseDocumentsQueue: any[] = [];
    private processing;

    /* @ngInject */
    constructor(
        private $log: ILogService,
        private loadingService: LoadingService,
        private applicationService: ApplicationService,
        private toaster: any,
        private $state: StateService,) {
    }

    public $onInit() {
        const priorUnits: PriorCourseUnit[] = this.application.priorStudies
            .map((course: PriorCourse): PriorCourseUnit[] => {
                return course.units;
            })
            .reduce((units, unit) => {
                return units.concat(unit);
            }, []);

        this.priorUnitMap = _.keyBy(priorUnits, (unit) => unit.unitCode);

        this.unitInstitutionMap = this.application.priorStudies
            .reduce((previousMap, course: PriorCourse) => {
                const unitMap = {};
                course.units.map((unit) => {
                    unitMap[unit.unitCode] = course.institution;
                });
                return _.merge(previousMap, unitMap);
            }, {});

        this.$log.debug("unitInstitutionMap", this.unitInstitutionMap);
        this.$log.debug("uploadedDocuments", this.application.supportingDocuments);
        this.getMessages();
    }

    private getMessages() {
        if (!this.isSystemAccepted()){
            this.messageIn2ndBox = "accepted by staff"
            this.messageIn4thBox = "total to be recorded in Callista"
            if (this.isSystemRejected()){
                this.messageIn4thBox = "total to be recorded in Callista"

            }
        }  else {
            this.messageIn2ndBox = "approved"
            this.messageIn4thBox = "total recorded in Callista"
        }
    }

    /**
     * Check if the application status indicates system acceptance.
     */
    public isSystemAccepted(): boolean {
        return checkSystemAccepted(this.application.status);
    }

    /**
     * Check if the application status indicates system rejection.
     */
    public isSystemRejected(): boolean {
        return checkSystemRejected(this.application.status);
    }

    /**
     * Check if file upload/remove actions should be disabled.
     * Returns true when the application is in a final or locked state.
     */
    public isFileUploadDisabled(): boolean {
        return this.application.status === 'ASSESSED_OFFLINE'
            || this.application.status === 'APPROVED'
            || this.application.status === 'DECLINED'
            || this.isSystemAccepted()
            || this.isSystemRejected();
    }

    public uploadCourseDocuments(attachments: any[], courseCode: string) {
        if (this.application.id !== undefined && this.application.id !== null && this.application.status !== "DRAFTED") {
            this.loadingService.show();
            this.processing = true;

            this.applicationService.uploadCourseDocumentByStaff(this.application.id, attachments, courseCode)
                .then((updatedApplication) => {
                    this.$log.debug("updatedApplication:", updatedApplication);
                    this.processing = false;

                    // Sync local courseDocuments with backend response to ensure remove button works correctly
                    if (updatedApplication.courseDocuments) {
                        this.application.courseDocuments = updatedApplication.courseDocuments;
                    }

                    this.toaster.pop({type: "success", title: "Course documents saved successfully"});

                })
                .finally(() => {
                        this.processing = false;
                        this.loadingService.hide();
                    }
                );
        }
    }

}

export const ApplicationSummaryComponent: IComponentOptions = {
    bindings: {
        application: "<",
        assessments: "<",
        applicationCourseOfferStatus: "<",
        currentUser: "<",
        approvedCreditPoints: "<",
        acceptedCreditPoints: "<",
        approvedAssessmentsCreditSummary: "<",
    },
    controller: ApplicationSummaryController,
    template: require("./application-summary.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/summary/application-summary.component.ts